import { render, staticRenderFns } from "./AttachmentSelectDialog.vue?vue&type=template&id=4f23b28a&scoped=true"
import script from "./AttachmentSelectDialog.vue?vue&type=script&lang=ts"
export * from "./AttachmentSelectDialog.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentSelectDialog.vue?vue&type=style&index=0&id=4f23b28a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f23b28a",
  null
  
)

export default component.exports